import { defineComponent, useSlots, computed, createElementBlock, openBlock, normalizeClass, createElementVNode, createCommentVNode, createVNode, mergeProps, withCtx, Fragment, renderList, renderSlot, createBlock, toDisplayString, createTextVNode } from 'vue';
import { useSlotContent } from './basler-components.es426.js';
import _sfc_main$1 from './basler-components.es211.js';
/* empty css                        */
import _sfc_main$4 from './basler-components.es85.js';
/* empty css                       */
import _sfc_main$2 from './basler-components.es110.js';
/* empty css                        */
import _sfc_main$5 from './basler-components.es114.js';
/* empty css                        */
import _sfc_main$3 from './basler-components.es81.js';
/* empty css                       */

const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "hero-article__inner" };
const _hoisted_3 = { class: "hero-article__content" };
const _hoisted_4 = {
  key: 0,
  class: "hero-article__title"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 1,
  class: "hero-article__title"
};
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  key: 2,
  class: "hero-article__subtitle"
};
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = {
  key: 3,
  class: "hero-article__description-list"
};
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = {
  key: 5,
  class: "hero-article__icon-list"
};
const _hoisted_14 = { class: "hero-article__icon-list-item-text" };
const _hoisted_15 = {
  key: 6,
  class: "hero-article__buttons"
};
const _hoisted_16 = {
  key: 0,
  class: "hero-article__media"
};
const _hoisted_17 = { class: "hero-article__media-inner" };
const _hoisted_18 = { class: "hero-article__media-inner-box" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "HeroArticleSection",
  props: {
    id: { default: "" },
    isContentIndented: { type: Boolean, default: false },
    title: {},
    secondTitle: {},
    subtitle: {},
    descriptionList: {},
    iconList: {},
    buttons: {},
    media: {},
    mediaOnTop: { type: Boolean, default: false },
    colorMode: { default: "light" },
    lazyload: { type: Boolean, default: false },
    rteTextIsCentered: { type: Boolean, default: true }
  },
  setup(__props) {
    const slots = useSlots();
    const { hasSlotContent } = useSlotContent();
    const hasRteTextSlotContent = computed(() => {
      return hasSlotContent(slots.rteText);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: _ctx.id,
        class: normalizeClass([
          "hero-article",
          { "hero-article--is-reversed": _ctx.mediaOnTop },
          { "is-content-indented": _ctx.isContentIndented },
          { "theme-light": _ctx.colorMode === "light" },
          { "theme-dark": _ctx.colorMode === "dark" }
        ])
      }, [
        createElementVNode("div", _hoisted_2, [
          createElementVNode("div", _hoisted_3, [
            _ctx.title ? (openBlock(), createElementBlock("div", _hoisted_4, [
              createVNode(_sfc_main$1, mergeProps({ ..._ctx.title, content: void 0 }, {
                level: _ctx.title?.level || 1,
                "badge-size": _ctx.title?.badgeSize || "medium",
                "is-centered": "isCentered" in _ctx.title ? _ctx.title.isCentered : true
              }), {
                default: withCtx(() => [
                  _ctx.title.content ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    innerHTML: _ctx.title.content
                  }, null, 8, _hoisted_5)) : createCommentVNode("", true)
                ]),
                _: 1
              }, 16, ["level", "badge-size", "is-centered"])
            ])) : createCommentVNode("", true),
            _ctx.secondTitle && _ctx.secondTitle.content ? (openBlock(), createElementBlock("div", _hoisted_6, [
              createVNode(_sfc_main$1, mergeProps({ ..._ctx.secondTitle, content: void 0 }, {
                "badge-size": _ctx.secondTitle?.badgeSize || "medium",
                "is-centered": "isCentered" in _ctx.secondTitle ? _ctx.secondTitle.isCentered : true
              }), {
                default: withCtx(() => [
                  _ctx.secondTitle.content ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    innerHTML: _ctx.secondTitle.content
                  }, null, 8, _hoisted_7)) : createCommentVNode("", true)
                ]),
                _: 1
              }, 16, ["badge-size", "is-centered"])
            ])) : createCommentVNode("", true),
            _ctx.subtitle && _ctx.subtitle.content ? (openBlock(), createElementBlock("div", _hoisted_8, [
              createVNode(_sfc_main$1, mergeProps(_ctx.subtitle, {
                level: _ctx.subtitle?.level || 2,
                tag: _ctx.subtitle?.tag,
                "is-centered": "isCentered" in _ctx.subtitle ? _ctx.subtitle.isCentered : true
              }), {
                default: withCtx(() => [
                  _ctx.subtitle.content ? (openBlock(), createElementBlock("span", {
                    key: 0,
                    innerHTML: _ctx.subtitle.content
                  }, null, 8, _hoisted_9)) : createCommentVNode("", true)
                ]),
                _: 1
              }, 16, ["level", "tag", "is-centered"])
            ])) : createCommentVNode("", true),
            _ctx.descriptionList ? (openBlock(), createElementBlock("dl", _hoisted_10, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.descriptionList, (item, index) => {
                return openBlock(), createElementBlock("div", {
                  key: index,
                  class: "hero-article__description-group"
                }, [
                  createElementVNode("dt", {
                    innerHTML: item.term
                  }, null, 8, _hoisted_11),
                  createElementVNode("dd", {
                    innerHTML: item.details
                  }, null, 8, _hoisted_12)
                ]);
              }), 128))
            ])) : createCommentVNode("", true),
            hasRteTextSlotContent.value ? (openBlock(), createElementBlock("div", {
              key: 4,
              class: normalizeClass(["hero-article__text", { "is-centered": _ctx.rteTextIsCentered }])
            }, [
              createVNode(_sfc_main$2, { lead: true }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "rteText")
                ]),
                _: 3
              })
            ], 2)) : createCommentVNode("", true),
            _ctx.iconList ? (openBlock(), createElementBlock("ul", _hoisted_13, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.iconList, (item, index) => {
                return openBlock(), createElementBlock("li", {
                  key: index,
                  class: "hero-article__icon-list-item"
                }, [
                  item.iconName ? (openBlock(), createBlock(_sfc_main$3, {
                    key: 0,
                    name: item.iconName,
                    class: "hero-article__icon-list-item-icon"
                  }, null, 8, ["name"])) : createCommentVNode("", true),
                  createElementVNode("p", _hoisted_14, toDisplayString(item.text), 1)
                ]);
              }), 128))
            ])) : createCommentVNode("", true),
            _ctx.buttons ? (openBlock(), createElementBlock("div", _hoisted_15, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.buttons, (item, index) => {
                return openBlock(), createBlock(_sfc_main$4, {
                  key: index,
                  link: item.link,
                  targetBlank: item.targetBlank,
                  size: item.size,
                  styleType: item.styleType,
                  iconType: item.iconType,
                  iconName: item.iconName
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(item.text), 1)
                  ]),
                  _: 2
                }, 1032, ["link", "targetBlank", "size", "styleType", "iconType", "iconName"]);
              }), 128))
            ])) : createCommentVNode("", true)
          ]),
          _ctx.media ? (openBlock(), createElementBlock("div", _hoisted_16, [
            createElementVNode("div", _hoisted_17, [
              createElementVNode("div", _hoisted_18, [
                createVNode(_sfc_main$5, {
                  media: _ctx.media,
                  cols: [10, 10, 12],
                  lazyload: _ctx.lazyload
                }, null, 8, ["media", "lazyload"])
              ])
            ])
          ])) : createCommentVNode("", true)
        ])
      ], 10, _hoisted_1);
    };
  }
});

export { _sfc_main as default };
